import { useState } from 'react'
import { Button, TextInput } from '@eltoro-ui/components'
import { PixelFormItem } from './shared'
import './PixelTagInput.scss'

const TAG_COUNT_LIMIT = 5
const TAG_LENGTH_LIMIT = 50

export const PixelTagInput = ({
  tags,
  setTags,
  disabled,
}: {
  tags: string[]
  setTags: (tags: string[]) => void
  disabled?: boolean
}) => {
  const [inputValue, setInputValue] = useState('')

  const addTag = () => {
    if (
      inputValue.trim() &&
      !tags.includes(inputValue.trim()) &&
      inputValue.trim().length <= 50
    ) {
      setTags([...tags, inputValue.trim()])
      setInputValue('')
    }
  }

  const removeTag = (tagToRemove: string) => {
    setTags(tags.filter((tag) => tag !== tagToRemove))
  }

  return (
    <div className="PixelTagInput">
      <div className="mb-2">
        {disabled && !tags.length ? (
          <div className="text-grey-500">
            <em>No tags to display</em>
          </div>
        ) : (
          tags.map((tag) => (
            <span
              key={tag}
              className="border border-primary text-primary mr-2 mb-2 inline-block rounded-full px-3 py-1 text-sm font-semibold"
            >
              {tag}{' '}
              {!disabled && (
                <span
                  className="ml-2 cursor-pointer"
                  onClick={() => removeTag(tag)}
                  tabIndex={0}
                  role="button"
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault()
                      removeTag(tag)
                    }
                  }}
                >
                  ✕
                </span>
              )}
            </span>
          ))
        )}
      </div>
      {!disabled && (
        <div className="flex w-full items-center gap-2">
          <PixelFormItem
            wrapperClassname="flex flex-col"
            label=""
            htmlFor="tag-input"
            valid={inputValue.trim().length <= TAG_LENGTH_LIMIT}
            counter={inputValue.trim().length > TAG_LENGTH_LIMIT - 10}
            className="w-full"
          >
            <TextInput
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              placeholder={
                tags.length >= TAG_COUNT_LIMIT
                  ? `Max tag limit (${TAG_COUNT_LIMIT}) reached. Please remove tags to create new.`
                  : 'Add new tag...'
              }
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault()
                  addTag()
                }
              }}
              maxLength={51}
              disabled={tags.length >= TAG_COUNT_LIMIT}
              className={
                tags.length >= TAG_COUNT_LIMIT ? 'tag-length-reached' : ''
              }
            />
          </PixelFormItem>
          <Button
            onClick={addTag}
            disabled={
              !inputValue.trim() ||
              tags.includes(inputValue.trim()) ||
              inputValue.trim().length > TAG_LENGTH_LIMIT ||
              tags.length >= TAG_COUNT_LIMIT
            }
            className={
              inputValue.trim().length > TAG_LENGTH_LIMIT - 10 ? 'mb-8' : ''
            }
          >
            Add Tag
          </Button>
        </div>
      )}
    </div>
  )
}
